import { useQuery } from "@tanstack/react-query";
import { useCurrentCompanyId } from "hooks/auth";
import { StaleTime } from "newui/store/tanstack-base";
import { getMySuppliers } from "../api/supplier-performance-api";
import { SUPPLIER_PERFORMANCE_QUERY_KEYS } from "../constants/query-keys";
import type {
	AwardedSupplierListResponse,
	MySuppliersFilters,
} from "../types/supplier-performance.types";

export const useMySuppliers = (filters: MySuppliersFilters) => {
	const companyId = useCurrentCompanyId();

	return useQuery<AwardedSupplierListResponse>({
		queryKey: SUPPLIER_PERFORMANCE_QUERY_KEYS.mySuppliers(
			companyId ?? 0,
			filters as unknown as Record<string, unknown>
		),
		queryFn: () => getMySuppliers(companyId!, filters),
		enabled: companyId !== null,
		staleTime: StaleTime.Short,
	});
};
